import React, { useState } from "react";
import Input from "./Input";
import Select from "./select/Select";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { countryList } from "../../services/countryService";
import { loadDataOnScroll, replaceOldData } from "../../helpers";

const PhoneInput = ({
  value = {},
  onChange = () => {},
  labelClasses,
  label,
  required,
}) => {
  const [countryFilter, setContryFilter] = useState(null);

  const { data: countryData } = useQuery({
    queryKey: ["country", countryFilter],
    queryFn: async () => {
      const res = await countryList({ ...countryFilter });
      if (countryFilter?.page > 1) {
        const marge_arr = [...(countryData?.data || []), ...res?.docs?.data];
        return {
          ...res?.docs,
          data: replaceOldData({
            oldData: marge_arr,
            newData: res?.docs?.data,
          }),
        };
      } else {
        return { ...res?.docs };
      }
    },
    placeholderData: keepPreviousData,
  });

  return (
    <div className="w-full relative">
      {label && (
        <div
          className={
            "text-xs font-medium text-text-disabled mb-1 font-CanelaDeck " +
            labelClasses
          }
        >
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <div className="flex items-center">
        <div className="w-20">
          <Select
            dropdownData={countryData?.data?.map((item) => ({
              name: item?.phone_code.includes("+")
                ? item?.phone_code
                : `+${item?.phone_code}`,
              value: item?.phone_code.includes("+")
                ? item?.phone_code
                : `+${item?.phone_code}`,
            }))}
            dropdownButtonClass={"rounded-l-md rounded-r-none !border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple"}
            selectedValue={
              value?.countryCode ||
              countryData?.data?.[0]?.phone_code?.includes("+")
                ? countryData?.data?.[0]?.phone_code
                : `+${countryData?.data?.[0]?.phone_code}`
            }
            onChange={(val) => {
              onChange({ ...value, countryCode: val });
            }}
            onScroll={(e) => {
              loadDataOnScroll({
                event: e,
                metadata: countryData?.metadata,
                setData: setContryFilter,
              });
            }}

          />
        </div>
        <Input
          value={value?.number || ""}
          onChange={(e) => onChange({ ...value, number: e.target.value })}
          inputName={"phone"}
          inputType="number"
          labelClasses={"!text-lg !text-deep-purple !mb-2"}
          inputClasses={
            "!border-surface-05 !bg-surface-04 !h-12 !font-medium !text-deep-purple rounded-l-none"
          }
        />
      </div>
    </div>
  );
};

export default PhoneInput;
